// MVP версия. Если зайдет то сделать уже нормально, с контейнером
import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import { SVGRepair } from "Constants/SVG";
import { CDN_URL } from "Constants/CDN";
import Button from "ComponentsUI/Button";

const useStyles = createUseStyles((theme) => ({
	root: {
		position: "relative",
		width: "400px",
		margin: "20px 0",
		padding: "20px 25px",
		border: `1px solid ${theme.palette.colors.cloudyBlue}`,
		borderRadius: "10px",
		backgroundColor: theme.palette.colors.white,
		fontFamily: theme.fonts.medium,
	},
	modalWrapper: {
		width: "348px",
		height: "auto",
		padding: "20px 15px",
		display: "flex",
		flexDirection: "row",
		position: "absolute",
		top: "50px",
		left: "25px",
		border: `1px solid transparent`,
		background: theme.palette.colors.charcoalGrey,
		borderRadius: "12px",
	},
	modalIcon: {
		width: "30px",
		height: "30px",
	},
	modalTextWrapper: {
		textAlign: "left",
		margin: "0 10px",
	},
	modalHeader: {
		color: theme.palette.colors.white,
		lineHeight: "19.2px",
		fontFamily: theme.fonts.medium,
		marginBottom: "5px",
	},
	modalText: {
		fontSize: "14px",
		lineHeight: "16px",
		color: theme.palette.colors.grey,
		fontFamily: theme.fonts.light,
	},
	modalButtonClose: {
		width: "15px",
		height: "15px",
		display: "flex",
		justifyContent: "flex-end",
		color: theme.palette.colors.grey,
		cursor: "pointer",
	},
	headerText: {
		margin: "0 0 20px",
		textAlign: "center",
		color: theme.palette.colors.darkSlateBlue,
		fontFamily: theme.fonts.bold,
		fontSize: "22px",
		lineHeight: "26px",
	},
	infoWrapper: {
		display: "flex",
		justifyContent: "space-around",
		color: theme.palette.colors.darkSlateBlue,
	},
	downloadInfo: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	uploadInfo: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	measure: {
		marginLeft: "5px",
		fontFamily: theme.fonts.light,
	},
	imgWrapper: {
		textAlign: "center",
		marginBottom: "20px",
	},
	img: {
		width: "268px",
		height: "150px",
	},
	buttonWrapper: {
		textAlign: "center",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {
			width: "380px",
			padding: "20px",
		},
		modalWrapper: {
			width: "328px",
			top: "50px",
		},
		img: {
			width: "178px",
			height: "100px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "300px",
			padding: "15px",
		},
		modalWrapper: {
			width: "100%",
			top: "50px",
			left: 0,
		},
		img: {
			width: "220px",
			height: "120px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
		},
		modalWrapper: {
			width: "100%",
			top: "50px",
			left: 0,
		},
		img: {
			width: "230px",
			height: "130px",
		},
	},
}));

// MVP версия. Если зайдет то сделать уже нормально, с контейнером
const CheckSpeed = (props) => {
	const [viewModal, setViewModal] = useState(false);
	const classes = useStyles();
	const { text, sendingStore } = props;

	const openModalHandler = (value) => {
		setViewModal((view) => value);
		sendingStore.sendMetriksAndSaveArray("CLICK_TEST_SCOR");
	};

	// return "TEST";
	return (
		<div className={classes.root}>
			<h3 className={classes.headerText}>{text.check_speed_internet}</h3>
			{viewModal && (
				<div className={classes.modalWrapper}>
					<div className={classes.modalIcon}>{SVGRepair}</div>
					<div className={classes.modalTextWrapper}>
						<div className={classes.modalHeader}>{text.repair_1}</div>
						<div className={classes.modalText}>{text.repair_2}</div>
					</div>
					<div className={classes.modalButtonClose}>
						<div onClick={() => openModalHandler(false)}>
							<span className="icon24 icon-close" />
						</div>
					</div>
				</div>
			)}
			<div className={classes.infoWrapper}>
				<div className={classes.downloadInfo}>
					<span>Загрузка</span>
					<div>
						<span>0</span>
						<span className={classes.measure}>Мбит/с</span>
					</div>
				</div>
				<div className={classes.uploadInfo}>
					<span>Отдача</span>
					<div>
						<span>0</span>
						<span className={classes.measure}>Мбит/с</span>
					</div>
				</div>
			</div>
			<div className={classes.imgWrapper}>
				<img className={classes.img} alt={"speedCheck"} src={`${CDN_URL}/images/SpeedCheck.svg`} />
			</div>
			<div className={classes.buttonWrapper}>
				<Button
					onClick={() => {
						openModalHandler(!viewModal);
					}}
					// fullWidth={true}
					size="low"
					status="purple"
				>
					{text.BEGIN}
				</Button>
			</div>
		</div>
	);
};

// MVP версия. Если зайдет то сделать уже нормально, с контейнером
export default CheckSpeed;
